<ion-content class="complete-registration" class="scroll">
  <h1 class="title-text">
    @if (profileCompleted) { Your tickets } @else {
      {{ "complete-registration.Complete" | translate }} <br />
      {{ "complete-registration.registration" | translate }}
    }
  </h1>
  <!-- viewReady transitions false→true exactly once (Ionic element registration).
       It never flips back, so form state cannot be lost due to re-creation. -->
  @if (!viewReady()) {
    <!-- Plain CSS spinner — avoids using Ionic elements before they are hydrated -->
    <div class="view-loading-state" role="status" [attr.aria-label]="'complete-registration.loading' | translate">
      <div class="view-loading-spinner" aria-hidden="true"></div>
    </div>
  } @else {
  @if (profileDecisionPending || profileSavePending || profileCompleted) {
    <ion-spinner name="lines-small" role="status" aria-label="Loading"></ion-spinner>
  }
  <div class="createacc-btn" [hidden]="profileCompleted || profileSavePending || profileDecisionPending">
    @if (this.facebook === facebookSign) {
      <ion-button id="btnFacebook" expand="block" [disabled]="!isOnlineSignal()" (click)="connect('facebook')"
        >
        <span class="button-inner">
          <span>{{ facebook }}</span>
        </span>
      </ion-button>
    }
    @if (this.google === gmailSign) {
      <ion-button id="btnGoogle" expand="block" (click)="connect('google')">
        <span class="button-inner">
          <span>{{ google }}</span>
        </span>
      </ion-button>
    }
  </div>
  <!-- Complete Registration Form -->
  <form [formGroup]="completeRegistrationForm" [hidden]="profileCompleted || profileDecisionPending">
    @if (!paidProfileMode) {
    <h1 class="text-registered-mobile">{{ "complete-registration.mobile" | translate }}</h1>
    <ion-grid class="ion-no-padding mobile-input">
      <ion-row>
        <ion-col size="3.2" class="ion-no-padding">
          <ion-item lines="none" class="ion-input-field">
            <ion-input type="tel" formControlName="dialCode" min="1" maxlength="4" placeholder="+44" class="signupfield"
            (input)="checkInput($event)" (keypress)="getNumericOnly($event)"></ion-input>
            <input id="dialCode" (countryChange)="onCell1CountryChange($event)"
              (intlTelInputObject)="telInputObject($event)" readonly style="display: none;" />
            </ion-item>
          </ion-col>
          <ion-col size="0.3" class="ion-no-padding"></ion-col>
          <ion-col size="8.5">
            <ion-item
              [ngClass]="completeRegistrationForm.get('phoneNumber')?.errors?.incorrectPhoneNumber ? 'invalid-field' : ''"
              lines="none" class="ion-input-field">
              <input type="tel" placeholder="{{ 'create-account.Your' | translate }}" maxlength="11" inputmode="numeric"
                accesskey="p" (hasError)="phoneNumberHasError($event)" class="signupfield signup-phone-number"
                (input)="getPhoneNumber($event)" formControlName="phoneNumber" autocomplete="false"
                (keypress)="getNumericOnly($event)" (click)="editPhoneNumber()" readonly />
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-grid>
        
    }
      <h1 class="standard-fields">{{ "complete-registration.Title" | translate }}</h1>
      <ion-item lines="none">
          <mat-form-field appearance="fill" class="transparent-bg full-width">
            <mat-select class="custom-select" matNativeControl required  formControlName="option" [placeholder]="'complete-registration.usertitle' | translate">  
             @for (option of titleOptions; track option) {
                <mat-option  [value]="option">{{ option }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
      </ion-item>
        <!-- <ion-item lines="none">
          <ion-input formControlName="option" placeholder="{{ 'complete-registration.usertitle' | translate }}"
            readonly="readonly" class="signupfield" value="{{ pickerValue }}" (click)="openPicker()">
          </ion-input>
        </ion-item> -->

        <h1 class="standard-fields">{{ "complete-registration.First" | translate }}</h1>
    <ion-item lines="none" [ngClass]="
      {'invalid-field':completeRegistrationForm.get('name').touched && completeRegistrationForm.get('name')?.errors}
      ">
          <ion-input formControlName="name" placeholder="{{ 'complete-registration.placeholder_first' | translate }}"
            class="signupfield" maxlength="15">
          </ion-input>
        </ion-item>
        @if (
          completeRegistrationForm.get('name').dirty &&
          completeRegistrationForm.get('name').invalid &&
          completeRegistrationForm.get('name').value?.length > 0
          ) {
          <div class="errorContainer" role="alert" aria-invalid="true" aria-describedby="name-length-error-message">
            <ion-icon name="warning" class="icon"></ion-icon>
            <span class="text" id="name-length-error-message">{{ "complete-registration.valid" | translate }}</span>
          </div>
        }
        @if (
          completeRegistrationForm.get('name').touched && completeRegistrationForm.get('name')?.errors?.required) {
          <div class="errorContainer" role="alert" aria-invalid="true" aria-describedby="name-required-error-message">
            <ion-icon name="warning" class="icon"></ion-icon>
            <span class="text" id="name-required-error-message">{{ "complete-registration.enter" | translate }}</span>
          </div>
        }

        <h1 class="standard-fields">{{ "complete-registration.Last" | translate }}</h1>
    <ion-item lines="none" [ngClass]="
        {'invalid-field':completeRegistrationForm.get('surname').touched && completeRegistrationForm.get('surname')?.errors}
      ">
          <ion-input formControlName="surname" placeholder="{{ 'complete-registration.placeholder_last' | translate }}"
            class="signupfield" maxlength="15">
          </ion-input>
        </ion-item>
        @if (
          completeRegistrationForm.get('surname').dirty &&
          completeRegistrationForm.get('surname').invalid &&
          completeRegistrationForm.get('surname').value?.length > 0
          ) {
          <div class="errorContainer" role="alert" aria-invalid="true" aria-describedby="surname-length-error-message">
            <ion-icon name="warning" class="icon"></ion-icon>
            <span class="text" id="surname-length-error-message">{{ "complete-registration.Please" | translate }}</span>
          </div>
        }
        @if (
          completeRegistrationForm.get('surname').touched && completeRegistrationForm.get('surname')?.errors?.required
          ) {
          <div class="errorContainer" role="alert" aria-invalid="true" aria-describedby="surname-required-error-message"
            >
            <ion-icon name="warning" class="icon"></ion-icon>
            <span class="text" id="surname-required-error-message">{{ "complete-registration.Please_enter" | translate
            }}</span>
          </div>
        }

        <h1 class="standard-fields">{{ "complete-registration.Email" | translate }}</h1>
    <ion-item lines="none" [ngClass]="
        {'invalid-field':completeRegistrationForm.get('email').touched && completeRegistrationForm.get('email')?.errors}
      ">
          <ion-input type="email" formControlName="email"
            placeholder="{{ 'complete-registration.placeholder_Email' | translate }}" maxLength="63" class="signupfield"
            (input)="autoFill($event,'email')">
          </ion-input>
        </ion-item>
        @if (completeRegistrationForm.get('email').touched && completeRegistrationForm.get('email')?.errors?.pattern) {
          <div class="errorContainer" role="alert" aria-invalid="true" aria-describedby="email-pattern-error-message"
            >
            <ion-icon name="warning" class="icon"></ion-icon>
            <span class="text" id="email-pattern-error-message">{{ "complete-registration.enter_valid" | translate }}</span>
          </div>
        }
        @if (completeRegistrationForm.get('email').touched && completeRegistrationForm.get('email')?.errors?.required) {
          <div class="errorContainer" role="alert" aria-invalid="true" aria-describedby="email-required-error-message"
            >
            <ion-icon name="warning" class="icon"></ion-icon>
            <span class="text" id="email-required-error-message">{{ "complete-registration.enter_email" | translate }}</span>
          </div>
        }
        <!-- confirm email -->
        <h1 class="standard-fields">{{ "complete-registration.confirm_email_address" | translate }}</h1>
    <ion-item lines="none" [ngClass]="
        {'invalid-field':completeRegistrationForm.get('cemail').touched && completeRegistrationForm.get('cemail')?.errors}
      ">
          <ion-input type="email" formControlName="cemail"
            placeholder="{{ 'complete-registration.confirm_email_address' | translate }}" maxLength="63" class="signupfield"
            (input)="autoFill($event,'cemail')">
          </ion-input>
        </ion-item>
        @if (completeRegistrationForm.get('cemail').touched && completeRegistrationForm.get('cemail')?.errors?.pattern) {
          <div class="errorContainer" role="alert" aria-invalid="true" aria-describedby="cemail-pattern-error-message"
            >
            <ion-icon name="warning" class="icon"></ion-icon>
            <span class="text" id="cemail-pattern-error-message">{{ "complete-registration.enter_valid" | translate }}</span>
          </div>
        }
        @if (completeRegistrationForm.get('email')?.value && !completeRegistrationForm.get('cemail')?.value) {
          <div class="errorContainer" role="alert" aria-invalid="true" aria-describedby="cemail-match-error-message"
            >
            <ion-icon name="warning" class="icon"></ion-icon>
            <span class="text" id="cemail-match-error-message">{{ "complete-registration.enter_confirm_email" | translate
            }}</span>
          </div>
        }
        @if (
          completeRegistrationForm.get('cemail')?.value &&
          completeRegistrationForm.get('cemail').touched &&
          !completeRegistrationForm.get('cemail')?.errors?.pattern &&
          completeRegistrationForm?.errors?.match_error
          ) {
          <div class="errorContainer two-line-error-message" role="alert" aria-invalid="true"
            aria-describedby="cemail-required-error-message">
            <ion-icon name="warning" class="icon"></ion-icon>
            <span class="text" id="cemail-required-error-message">{{ "complete-registration.match_email_error" | translate
            }}</span>
          </div>
        }
        <!-- end -->
        <h1 class="standard-fields">{{ "complete-registration.Birth" | translate }}</h1>
    <ion-item lines="none" [ngClass]="
     {'invalid-field':completeRegistrationForm.get('date_of_birth').touched && completeRegistrationForm.get('date_of_birth')?.errors}
    "><ion-input (pointerdown)="openDateModal($event)" id="date" formControlName="date_of_birth"
          [placeholder]="'your-details.chooseDate' | translate">
        </ion-input>
      </ion-item>
      <ion-modal #popover [isOpen]="isDateModalOpen" class="date" (didDismiss)="closeDateModal()">
        <ng-template>
          <div class="date-picker1">
            <!-- using the wheel date picker insted of pervious -->
            <ion-datetime mode="ios" [preferWheel]="true" (ionChange)="onDateChange($event)" class="datetime-calendar"
              presentation="date" [value]="defaultDateOfBirth" [max]="maxDateOfBirth" displayFormat="M/D/YYYY" pickerFormat="MMM D YYYY"
              [locale]="selectedLanguage"></ion-datetime>
          </div>
        </ng-template>
      </ion-modal>
      @if (
        completeRegistrationForm.get('date_of_birth').touched &&
        completeRegistrationForm?.get('date_of_birth')?.errors?.required
        ) {
        <div class="errorContainer" role="alert" aria-invalid="true" aria-describedby="dob-required-error-message">
          <ion-icon name="warning" class="icon"></ion-icon>
          <span class="text" id="dob-required-error-message">{{ "complete-registration.enter_date" | translate }}</span>
        </div>
      }
      @if (
        completeRegistrationForm.get('date_of_birth').touched &&
        completeRegistrationForm?.get('date_of_birth')?.errors?.futureInvalidDate
        ) {
        <div class="errorContainer two-line-error-message" role="alert" aria-invalid="true"
          aria-describedby="dob-invalid-error-message">
          <ion-icon name="warning" class="icon"></ion-icon>
          <span class="text" id="dob-invalid-error-message">{{ "complete-registration.valid_age" | translate }}</span>
        </div>
      }

      <!-- <div *ngIf="!preferredCurrencyExists">
      <h1 class="standard-fields">{{ "complete-registration.preferred" | translate }}</h1>
      <ion-item lines="none">
        <ion-input
          class="title-drop-down"
          formControlName="currency"
          placeholder="GBP"
          readonly="readonly"
          class="signupfield"
          value="{{ preferredCurrency }}"
          (click)="openCurrencyPicker()"
          >
        </ion-input>
      </ion-item>
    </div> -->

    <ion-button class="action-btn-large" expand="block" (click)="completeRegistrationIfValidUser()"
      [disabled]="completeRegistrationForm.invalid || profileSaveInProgress || profileSavePending">
      @if (proceed && !spinnerAnimation) {
        <p>{{ "complete-registration.Proceed" | translate }}</p>
      }
      @if (spinnerAnimation) {
        <div class="spinners">
          <!-- <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40"></mat-progress-spinner>
          <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
          </mat-progress-spinner> -->
          <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
          </mat-progress-spinner>
        </div>
      }
      @if (!proceed) {
        <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
      }
    </ion-button>
    <br />
    <div class="text-note">
      {{ "complete-registration.notes" | translate }}
      <span (click)="openPreference()">{{ "complete-registration.click" | translate }}
      </span>
    </div>
  </form>
  }
</ion-content>
